var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiners(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0269 29.592C21.4015 29.5397 27.3373 23.5188 27.2849 16.144C27.2326 8.76928 21.2118 2.8333 13.8372 2.88566C6.46266 2.93802 0.526822 8.95889 0.579183 16.3337C0.631543 23.7084 6.65228 29.6444 14.0269 29.592Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9505 29.8288C6.29794 29.8652 0 23.6655 0 16.1188C0 7.87134 6.29794 2.16666 13.9505 2.16797H17.5366C25.0982 2.16666 32 7.86866 32 16.1188C32 23.6628 25.0982 29.8288 17.5366 29.8288H13.9505ZM13.9812 3.31191C6.98825 3.31459 1.323 8.98147 1.32169 15.9744C1.323 22.9667 6.98825 28.6323 13.9812 28.6336C20.9745 28.6323 26.6417 22.9667 26.6434 15.9744C26.6416 8.98147 20.9744 3.31459 13.9812 3.31191ZM11.1069 23.4618V8.48509C8.09806 9.64384 5.96375 12.5562 5.956 15.9744C5.96369 19.392 8.09806 22.3044 11.1069 23.4618ZM22.0077 15.9744C22.002 12.5549 19.8642 9.63841 16.8531 8.48372V23.4645C19.8642 22.3084 22.002 19.3947 22.0077 15.9744Z",
    fill: "#004A98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiners);
export default __webpack_public_path__ + "static/media/diners.126de75e6047dbdec6a069ec00d0951d.svg";
export { ForwardRef as ReactComponent };